import { useState, useEffect } from 'react';

/**
 * Returns current timestamp that updates at the given interval.
 * Use for temporal checks (e.g. waitingForPayment actionable) that should re-evaluate over time.
 */
export default function useNow(intervalMs = 30_000) {
  const [nowTs, setNowTs] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNowTs(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return nowTs;
}
